import axios from 'axios';
import {actions as A} from '../constants/actions';
import {api} from '../constants/api';

export const logout = (accessToken) => async dispatch => {
  try {
    if (accessToken) {
      await logoutFromServer();
    }
  } finally {
    dispatch({type: A.LOGOUT})
  }
};

const logoutFromServer = () => {
  return axios.post(api.LOGOUT, {});
};
